<template>
    <div></div>
</template>

<script>
export default {
    name: 'Finance'
};
</script>

<style scoped>

</style>
